import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function usePayPeriodPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "pay_periods:read"),
    canApprove: roleHasPermission(role, "pay_periods:approve"),
    canLock: roleHasPermission(role, "pay_periods:lock"),
    canExport: roleHasPermission(role, "exports:full_payroll"),
    canViewPayroll: roleHasPermission(role, "payroll:sensitive"),
    canUnlock: role === "OWNER" || role === "ADMIN",
    role,
  };
}
